export function repeatString(str, times) {
    var result = "";
    for (var i = 0; i < times; i++) {
        result += str;
    }
    return result;
}
export function reverseString(str) {
    return str.split("").reverse().join("");
}
export function strEndsWith(str, symbol) {
    return str && str.lastIndexOf(symbol) == (str.length - symbol.length);
}
/**
 * Adds two paths and returns the result
 * Correctly processes leading and trailing slashes
 * @param path1
 * @param path2
 */
export function combinePath(path1, path2) {
    var result = path1;
    if (result != null && result.length > 0) {
        if (result.charAt(result.length - 1) != '/')
            result += "/";
        result += path2;
    }
    else {
        result = path2;
    }
    return result;
}
//# sourceMappingURL=string_utils.js.map